import { UserModel } from '@/features/login-and-signup/types/user-model';
import { UserAuthModel, useCities, useDialog, useGuest } from '../state';

import isEmpty from 'lodash/isEmpty';
import shallow from 'zustand/shallow';

/* 
  this hook is used to display 'select city form' when cities' ids changes from backend side.
  NOTE: this case has been solved from backend side but this hook provides extra safety
*/

export const useCheckClientCity = () => {
  const setDialog = useDialog(s => s.setDialog, shallow);
  const guest = useGuest(s => s.guest, shallow);
  const cities = useCities(s => s.cities, shallow);

  const { citiesList } = cities;

  const checkUserCity = (user: UserAuthModel | UserModel) => {
    if (
      !user?.preferredCityId ||
      (!isEmpty(citiesList) && !citiesList.find(city => city.id === user.preferredCityId))
    ) {
      setDialog({});
      setTimeout(() => {
        setDialog({
          wrapper: true,
          isCitiesForm: true,
          citiesFormPayload: {
            isUser: true,
          },
        });
      }, 500);
    } else {
      setDialog({});
    }
  };

  const checkGuestCity = () => {
    if (
      !guest?.preferredCityId ||
      (!isEmpty(citiesList) &&
        !citiesList.find(city => city.id === guest.preferredCityId))
    ) {
      setDialog({});
      setTimeout(() => {
        setDialog({
          wrapper: true,
          isCitiesForm: true,
          citiesFormPayload: {
            isUser: false,
          },
        });
      }, 500);
    } else {
      setDialog({});
    }
  };

  return {
    checkUserCity,
    checkGuestCity,
  };
};
